import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { Icon } from "@/lib/icons";
import { Txt } from "@/components/Txt";
import { openBoardFile } from "@/lib/openFile";

const fmt = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");

export default function BoardDocuments() {
  const [docs, setDocs] = useState(undefined);
  const [q, setQ] = useState("");
  const load = useCallback(async () => {
    const r = await api.get("/board-documents");
    setDocs(r.data.documents);
  }, []);
  useEffect(() => { load(); }, [load]);

  const term = q.trim().toLowerCase();
  const filtered = (docs || []).filter(
    (d) => !term || (d.name || "").toLowerCase().includes(term) || (d.meeting_title || "").toLowerCase().includes(term)
  );

  return (
    <div data-testid="board-documents-page">
      <h1 className="font-zilla text-3xl sm:text-4xl font-semibold mb-1">
        <Txt id="governance.documents.title" screen="Board documents">Documents</Txt>
      </h1>
      <p className="text-[16px] text-ink/70 mb-5">
        <Txt id="governance.documents.subtitle" screen="Board documents">Every document attached to a board meeting, gathered in one place.</Txt>
      </p>

      <div className="relative mb-4 max-w-md">
        <Icon name="Search" className="w-4 h-4 text-ink/40 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          data-testid="board-documents-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search documents"
          className="w-full bg-cream border border-ink/15 rounded-lg pl-9 pr-3 py-2.5 min-h-[44px] text-[15px]"
        />
      </div>

      {docs === undefined ? (
        <div className="text-ink/60 py-8">Loading…</div>
      ) : filtered.length === 0 ? (
        <div className="bg-cream border border-ink/15 rounded-xl p-10 text-center text-ink/55" data-testid="board-documents-empty">
          {docs.length === 0 ? "No board documents yet. Documents attached to any meeting will appear here." : "No documents match your search."}
        </div>
      ) : (
        <div className="bg-cream border border-ink/15 rounded-xl overflow-hidden">
          {filtered.map((d) => (
            <div key={d.meeting_id + d.id} data-testid={`board-doc-${d.id}`} className="flex items-center gap-3 px-4 py-3 border-b border-ink/8 last:border-0">
              <Icon name="FileText" className="w-5 h-5 text-olive shrink-0" />
              <div className="min-w-0 flex-1">
                <a href={d.url || "#"} onClick={(e) => openBoardFile(e, d.meeting_id, d)} target="_blank" rel="noreferrer" className="text-dark-olive underline text-[15px] font-semibold break-words" data-testid={`board-doc-link-${d.id}`}>{d.name}</a>
                <div className="text-[12px] text-ink/55">{d.meeting_title ? `${d.meeting_title} · ` : ""}{fmt(d.meeting_date)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
